<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Senarai Rekod Ternakan">
		  <z-table :headers="table.headers" :items="table.items" :meta="table.meta">
          <!-- <template #button v-if="$zutil.role('2') || $zutil.role('1')">
            Senarai Rekod Penilaian Prestasi Ternakan
              <w-button dark class="green--bg ml1" :route="'#'" >
                  <w-icon class="mr1">fal fa-plus</w-icon> Tambah
              </w-button>
          </template> -->
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
            TINDAKAN
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
        <template #item-cell.tarikh_lahir="{ item, label, header, index }">
          {{$zutil.dateformat(item.tarikh_lahir)}}
        </template>
        <template #item-cell.tarikh_timbang="{ item, label, header, index }">
          {{$zutil.dateformat(item.tarikh_timbang)}}
        </template>
         <template #item-cell.umur="{ item, label, header, index }">
          {{$zutil.umurHari(item.tarikh_lahir, item.tarikh)}}
        </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
		        <!-- <inertia-link :href="$route('ternakan.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
            </inertia-link> -->
             &nbsp;  
          <template v-if="item.lkp_status_id == 36">
            <w-button  bg-color="warning"  :route="$route('art.ternakan.show',item.id)" class="be fs-2">
              <w-icon xs class="mr2">fal fa-pencil</w-icon>
            </w-button>
            
          </template>

            
		      </w-flex>
		    </template>
		  </z-table>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'ppt',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Rekod Ternakan', route: '/art/ternakan' },
      ]
      
    }
  },
  methods: {
    
  
  },

  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
